import { useEffect, useState } from "react";
import { deleteCategory, getCategory } from "../../../shared/services/services";
import { CategoryDetails } from "../../../shared/services/interface";
import { errorHandling } from "src/shared/services/errorHandling";
import { notifySuccess } from "src/assets/toastService";

interface CategoryPageResponse {
  category_details: CategoryDetails[];
  totalCount?: number;
  totalPages?: number;
  currentPage?: number;
  [key: string]: any;
}

const useCategory = (
  reFresh: boolean = false,
  Deleted?: boolean,
  page?: number,
  row?: number,
  search?: string,
  sortField?: string,
  order?: string
) => {
  const [category, setCategory] = useState<CategoryDetails[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [categoryPage, setCategoryPage] = useState<CategoryPageResponse | null>(null);
  const [error, setError] = useState<any>(null);

  const getData = () => {
    getCategory(Deleted, page, row, search, sortField, order)
      .then((res) => {
        const filtered: CategoryDetails[] = res.data.category_details;
        setCategory(filtered);
        setCategoryPage(res.data);
      })
      .catch((err) => {
        console.error(err);
        setError(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    setError(null);
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reFresh, Deleted, search, page, row, sortField, order]);

  const DeleteCategory = async (ids: string[]) => {
    setLoading(true);
    try {
      deleteCategory(ids).then((res) => {
        getData();
        notifySuccess("Category deleted successfully!");
      });
    } catch (error) {
      errorHandling(error);
    } finally {
      setLoading(false);
    }
  };

  return { category, loading, categoryPage, error, DeleteCategory };
};

export default useCategory;
